'use strict';

angular.module('selfAccessRequestControllers')

    .controller('AdHocOtherNeedsController', ['$scope', '$q', '$state', '$translate', 'topBar', '$modal', '$stateParams', '$timeout', 'selfAccessRequestService', 'selfAccessRequest', 'searchService', 'processStep', 'decisionLookUpsById',
        function ($scope, $q, $state, $translate, topBar, $modal, $stateParams, $timeout, selfAccessRequestService, selfAccessRequest, searchService, processStep, decisionLookUpsById) {

            // Load translation asynchronously to avoid race condition
            $translate('iam.selfAccessRequest.adHoc.pageTitle').then(function(translation) {
                topBar.setTitleAndIcon(translation + ' &nbsp;<i class="fa fa-chevron-right fa-align"></i>&nbsp; ' +
                                 '<i class="' + processStep.CssIcon + '"></i> ' + processStep.StepTitleEN, 'fa-shopping-cart');
            });

            // Variables
            var requestTimeout;

            // Scope Variables
            $scope.followUp = {};
            $scope.processStep = processStep;

            selfAccessRequestService
              .getSpecialNeedsFollowup($stateParams.userAccessRequestId)
              .then(function (followUp) {
                  if (!_.isEmpty(followUp)) {
                      $scope.followUp = followUp;
              }
            });

            $scope.completeSpecialNeeds = function () {
                selfAccessRequestService
                   .createOrUpdateSpecialNeedsFollowup($stateParams.userAccessRequestId, $scope.followUp)
                   .then(function (selfAccessRequest) {
                       selfAccessRequestService
                        .confirmProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, 'SpecialNeeds')
                        .then(function (selfAccessRequest) {
                            $state.go(selfAccessRequest.SelfRequestPageRoute, {}, {reload:true});

                        });
                   });

            }
        }
    ]);